/* istanbul ignore file  */

import { AxiosError, AxiosResponse } from 'axios';
import { IS_TEST_MODE } from 'consts';
import { ParsedDescopeTheme } from 'modules/theme/theme';
import { QueryCache, QueryClient } from 'react-query';
import { AdminPortalConfig } from 'types/adminPortalConfig';
import { IServerFeatureFlags } from 'types/featureflags';
import { qk } from './apiRoutes';

export const generateQueryClient = (options?: {
	appConfig?: AdminPortalConfig;
	theme?: ParsedDescopeTheme;
	featureFlags?: IServerFeatureFlags;
	onError?: (error: AxiosError) => void;
}) => {
	const qc = new QueryClient({
		defaultOptions: {
			queries: {
				retry: IS_TEST_MODE
					? false
					: (count, error) => {
							const httpResponse = error as AxiosResponse;
							return httpResponse?.status >= 500;
						},
				staleTime: !IS_TEST_MODE ? 1000 * 4 : Infinity
			}
		},
		queryCache: new QueryCache({
			onError: (error: any) => {
				if (error.response?.status === 401) {
					options?.onError?.(error as AxiosError);
				}
			}
		})
	});

	if (options?.appConfig) {
		qc.setQueryData(qk.adminPortalConfig(), options?.appConfig);
	}

	if (options?.theme) {
		qc.setQueryData(qk.theme(), options.theme);
	}

	if (options?.featureFlags) {
		qc.setQueryData(qk.featureFlags(), options.featureFlags);
	}

	return qc;
};
